import React, { FC, useEffect, useState } from "react";
import { ICommonProps } from "../../types/propTypes";
import ChargingService from "../../services/charging/charging-service";
import { IVatReceipt } from "../../models/charging";
import StandardResponse from "../../models/standard-response";
import { PDFViewer } from "@react-pdf/renderer";
import NoDataReceipt from "./NoDataReceipt";
import { useParams } from "react-router-dom";

const chargingService = new ChargingService();
const DownloadVATReceipt: FC<ICommonProps> = (props) => {
  const { t } = props;
  const { session_id } = useParams();
  const [receiptDetails, setReceiptDetails] = useState<IVatReceipt | null>(
    null
  );
  const [isAPICalled, setIsAPICalled] = useState<boolean>(false);

  useEffect(() => {
    if (session_id) {
      getReceiptData();
    }
  }, []);

  const getReceiptData = async () => {
    const inputData = {
      encrypted_session_id: session_id,
      is_download: false,
    };

    await chargingService
      .getDownloadReceiptData(inputData)
      .then(async (res: StandardResponse<IVatReceipt>) => {
        const pdfDownloadLink = res.Data.invoice_url;
        if (pdfDownloadLink !== "") {
          window.open(pdfDownloadLink, "_self");
          setReceiptDetails(res.Data);
          setTimeout(() => {
            window.close();
          }, 2000);
        }
      })
      .catch((m) => {
        setReceiptDetails(null);
      })
      .finally(() => {
        setIsAPICalled(true);
      });
  };

  return (
    <>
      <div className="download-receipt-container">
        {!isAPICalled && (
          <div className="loading-container">
            <div className="download-spinner"></div>
            <h2>{t("history.receipt.content.vatReceiptLoadingMessage")}</h2>
            <p>{t("history.receipt.content.vatReceiptDownloadMessage")}</p>
          </div>
        )}
        {isAPICalled && receiptDetails === null && (
          <PDFViewer style={{ width: "100%", height: "800px" }}>
            <NoDataReceipt t={t} />
          </PDFViewer>
        )}
      </div>
    </>
  );
};
export default DownloadVATReceipt;
